import React from 'react'
import scss from '../images/scss.jpg'
import logo from '../images/NC_logo.png'
import jnu from '../images/jnu_logo.png'
import { motion } from 'framer-motion'
import { useRef, useState, useEffect } from "react";
import background from '../images/compress_background.jpg'


function Home() {
  return (
    <div className="container">
            
                <div class="row my-5">
                  <div class="col-sm-6 mb-3 mb-sm-0 my-5">
                    <motion.div className="card border-0"
                        style={{ width: ' 22rem', height:'18rem', background: 'None'}}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}>

                        <div className="text-center">
                          <img className="card-image-top" src={logo} alt="Logo" width="110" height="200" />
                          <h1><strong>Net<span style={{color:"orangered"}}>Crypt</span> </strong></h1>
                        </div>
                        
                      </motion.div>
                  </div>
                 
                  <div class="col-sm-6">
                    <motion.div class="card text-white" style={{background:"#BE2727"}} initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}>
                      <div class="card-body">
                        <h5 class="card-title">About NetCrypt</h5>
                        <p class="card-text" style={{textAlign:"justify"}}>The International Conference on the Network and Cryptology (NetCrypt) with machine learning is focusing on all aspects of cryptology, network security, privacy, and cyber security, attracting cutting-edge results from world-renowned scientists in the area. The objective of NetCrypt 2026 is to provide a platform for researchers, engineers, academicians as well as industrial professionals from all over the world to present their research results and development activities in Communications and Network Engineering. This conference provides opportunities for the delegates to exchange new ideas and application experiences face to face, to establish business or research relations and to find global partners for future collaboration. It aims to provide a forum for researchers, engineers and practitioners interested in the application of information, networks and communication to discourse on research and development, professional practice in related fields.</p>
                      </div>
                    </motion.div>
                  </div>
                </div>

                <div class="row my-5">
                  <div class="col-sm-6 mb-3 mb-sm-0 my-5">
                    <motion.div class="card text-white" style={{background:"#2C99D5"}} initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}>
                      <div class="card-body">
                        <h5 class="card-title">Scope of NetCrypt</h5>
                        <p class="card-text" style={{textAlign:"justify"}}>Networks are currently witnessing a significant transformation that is resulting in new ways to address the deployment of applications and services in a digital society. Over the years, the focus of the conference has shifted from raising awareness towards sharing security event histories and discussing solutions and protection strategies. The main objective of this conference is to emphasize the recent technological developments in broadband high-speed networks, peer-to-peer networks, wireless and mobile networks which have led to new challenging problems, such as providing QoS support to the emerging multimedia applications across both wired and wireless networks. It will serve as a forum for researchers from both electronics engineering and computer science to present latest research results on QoS, Authentication,  reliability, Trust management,  security and robustness issues for both wired and wireless networks with the hope that Computer and Electronics practitioners will work together to develop networks methodologies. The conference will feature prominent invited speakers as well as papers by top researchers in the field from all over the world.</p>
                      </div>
                    </motion.div>
                  </div>
                 
                  <div class="col-sm-6">

                     <motion.div className="card border-0"
                        style={{ width: ' 22rem', height:'18rem', background: 'None'}}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, ease: 'easeOut' }}>

                        <div className="text-center">
                          <img className="card-image-top my-5" src={jnu} alt="Logo" width="160" height="200" />
                        </div>
                        
                        
                      </motion.div>
                    
                  </div>
                </div>


                
          </div>
  )
}

export default Home